document.addEventListener("DOMContentLoaded", function () {
	const tracks = document.querySelectorAll(".scrolling-logos__track");
	if (!tracks.length) return;

	var PIXELS_PER_SECOND = 50;

	tracks.forEach(function (track) {
		var images = track.querySelectorAll("img");
		var slider = track.closest(".scrolling-logos__slider");

		function initTrack() {
			var originalHTML = track.innerHTML;
			var viewportWidth = window.innerWidth;

			// Keep duplicating the original set until it exceeds the viewport width
			// This ensures there's enough content for a seamless loop
			while (track.scrollWidth < viewportWidth) {
				track.innerHTML += originalHTML;
			}

			// Now duplicate everything once more for the seamless -50% loop
			track.innerHTML += track.innerHTML;

			// Set animation duration based on half the track (one full set) for consistent speed
			var halfWidth = track.scrollWidth / 2;
			var duration = halfWidth / PIXELS_PER_SECOND;
			track.style.animationDuration = duration + "s";
		}

		// Wait for all logo images to load before cloning
		if (images.length === 0) {
			initTrack();
			return;
		}

		var loadedCount = 0;
		var totalImages = images.length;

		function onImageReady() {
			loadedCount++;
			if (loadedCount >= totalImages) {
				initTrack();
			}
		}

		images.forEach(function (img) {
			if (img.complete) {
				onImageReady();
			} else {
				img.addEventListener("load", onImageReady);
				img.addEventListener("error", onImageReady);
			}
		});
	});
});
